import React from 'react';

import { IAd, IAdsAnalyticsListRequest, IAdsStatisticsListRequest, ViewStatusSourceTypeEnum } from '../../api/ads';
import Filters from '../../components/Filter';
import { DateField, Select } from '../../components/Form';
import { IKiosk } from '../../api/kiosks';


const today = new Date();
const monthAgo = new Date();

monthAgo.setMonth(monthAgo.getMonth() - 1);

export const defaultFilter: IAdsStatisticsListRequest = {
    periodFrom: monthAgo.toISOString(),
    periodTo: today.toISOString(),
    kioskId: undefined,
    entityId: undefined,
};

interface IProps {
    filter: IAdsAnalyticsListRequest;
    kiosks: IKiosk[];
    ads: IAd[];
    onApply: any;
}

const sourceTypeOptions = [
    { value: '', label: 'Все' },
    { value: ViewStatusSourceTypeEnum.AD, label: 'Реклама' },
    { value: ViewStatusSourceTypeEnum.NEWS, label: 'Новости' },
]

export default function AdStatisticsFilter({ filter, kiosks, ads, onApply }: IProps) {
    const kiosksList = kiosks.map((k) => ({ value: k.id, label: k.name }));
    const adsList = ads.map((a) => ({ value: a.id, label: a.name }));

    kiosksList.unshift({ value: 0, label: 'Любой' });
    adsList.unshift({ value: 0, label: 'Любая' });

    return (
        <Filters initial={filter} onSubmit={onApply} btnText="Применить">
            <DateField name="periodFrom" label="Период с" max={today}/>
            <DateField name="periodTo" label="Период по" max={today}/>
            <Select name="kioskId" label="Киоск" options={kiosksList} margin="dense" noEmptyOption/>
            <Select name="entityId" label="Реклама" options={adsList} margin="dense" noEmptyOption/>
            <Select name="sourceType" label="Тип" options={sourceTypeOptions} margin="dense" noEmptyOption/>
        </Filters>
    );
}
